import React from "react";

interface OutboundCallIconProps {
  className?: string;
}

const OutboundCallIcon: React.FC<OutboundCallIconProps> = ({
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      className={className}
    >
      <path
        d="M12.8152 11.6528C12.8152 11.8628 12.7685 12.0786 12.6693 12.2886C12.5702 12.4986 12.4418 12.697 12.2727 12.8836C11.9868 13.1986 11.6718 13.4261 11.316 13.572C10.966 13.7178 10.5868 13.7936 10.1785 13.7936C9.58352 13.7936 8.94768 13.6536 8.27685 13.3678C7.60602 13.082 6.93518 12.697 6.27018 12.2128C5.59935 11.7228 4.96352 11.1803 4.35685 10.5795C3.75602 9.97279 3.21352 9.33695 2.72935 8.67195C2.25102 8.00695 1.86602 7.34195 1.58602 6.68279C1.30602 6.01779 1.16602 5.38195 1.16602 4.77529C1.16602 4.37862 1.23602 3.99945 1.37602 3.64945C1.51602 3.29362 1.73768 2.96695 2.04685 2.67529C2.42018 2.30779 2.82852 2.12695 3.26018 2.12695C3.42352 2.12695 3.58685 2.16195 3.73268 2.23195C3.88435 2.30195 4.01852 2.40695 4.12352 2.55862L5.47685 4.46612C5.58185 4.61195 5.65768 4.74612 5.71018 4.87445C5.76268 4.99695 5.79185 5.11945 5.79185 5.23029C5.79185 5.37029 5.75102 5.51029 5.66935 5.64445C5.59352 5.77862 5.48268 5.91862 5.34268 6.05862L4.89935 6.51945C4.83518 6.58362 4.80602 6.65945 4.80602 6.75279C4.80602 6.79945 4.81185 6.84029 4.82352 6.88695C4.84102 6.93362 4.85852 6.96862 4.87018 7.00362C4.97518 7.19612 5.15602 7.44695 5.41268 7.75029C5.67518 8.05362 5.95518 8.36279 6.25852 8.67195C6.57352 8.98112 6.87685 9.26695 7.18602 9.52945C7.48935 9.78612 7.74018 9.96112 7.93852 10.0661C7.96768 10.0778 8.00268 10.0953 8.04352 10.1128C8.09018 10.1303 8.13685 10.1361 8.18935 10.1361C8.28852 10.1361 8.36435 10.1011 8.42852 10.037L8.87185 9.59945C9.01768 9.45362 9.15768 9.34279 9.29185 9.27279C9.42602 9.19112 9.56018 9.15029 9.70601 9.15029C9.81685 9.15029 9.93352 9.17362 10.0618 9.22612C10.1902 9.27862 10.3243 9.35445 10.4702 9.45362L12.401 10.8245C12.5527 10.9295 12.6577 11.052 12.7218 11.1978C12.7802 11.3436 12.8152 11.4895 12.8152 11.6528Z"
        stroke="currentColor"
        strokeWidth="0.875"
        strokeMiterlimit="10"
      />
      <path
        d="M11.6652 3.29395H8.86523M11.6652 3.29395V6.09395V3.29395Z"
        stroke="currentColor"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OutboundCallIcon;
